import { useEffect, useState } from "react";
import { cn } from "@nexus/ui";
import { avatarColor } from "@/lib/avatar-color";
import { formatBrandName } from "../../lib/format";

interface BrandMarkProps {
  label: string;
  logoUrl?: string | null;
  kind: "you" | "competitor";
  className?: string;
}

function brandInitial(label: string): string {
  const formatted = formatBrandName(label);
  return formatted.charAt(0).toUpperCase() || "?";
}

/** Brand logo, falling back to a colored initial when there is no logo or it fails to load. */
export function BrandMark({ label, logoUrl, kind, className }: BrandMarkProps) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [logoUrl]);

  if (logoUrl && !failed) {
    return (
      <img
        src={logoUrl}
        alt=""
        aria-hidden
        data-brand-mark={kind}
        onError={() => setFailed(true)}
        className={cn("size-4 shrink-0 rounded-full object-cover", className)}
      />
    );
  }

  return (
    <span
      className={cn(
        "flex size-4 shrink-0 items-center justify-center rounded-full text-[9px] font-bold uppercase text-white",
        className,
      )}
      style={{ backgroundColor: avatarColor(label) }}
      aria-hidden
      data-brand-mark={kind}
    >
      {brandInitial(label)}
    </span>
  );
}
